var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEconomicallyValuableOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1H11.5C5.70101 1 1 5.70101 1 11.5V20.5C1 26.299 5.70101 31 11.5 31H20.5C26.299 31 31 26.299 31 20.5V11.5C31 5.70101 26.299 1 20.5 1Z",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.776 17.5552C13.776 18.4162 14.4388 19.1095 15.2541 19.1095H16.9226C17.6388 19.1095 18.2103 18.5 18.2103 17.7533C18.2103 16.9381 17.8522 16.6486 17.3265 16.4657L14.6446 15.5286C14.1188 15.3457 13.7607 15.0562 13.7607 14.241C13.7607 13.4943 14.3398 12.8848 15.0484 12.8848H16.7169C17.5322 12.8848 18.195 13.5781 18.195 14.4391",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 12V20",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3357 15.9998C24.3357 20.5998 20.6072 24.3355 16 24.3355C11.3929 24.3355 7.66431 20.6069 7.66431 15.9998C7.66431 11.3926 11.3929 7.66406 16 7.66406",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3357 10.9998V7.66406H21",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1643 11.8355L24.3357 7.66406",
    stroke: "#A5BAB1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEconomicallyValuableOff);
export default __webpack_public_path__ + "static/media/economically_valuable_off.ffd19e5f8944556c165b8e9f35116fa8.svg";
export { ForwardRef as ReactComponent };